import type { ContainerDirective, LeafDirective, TextDirective } from 'mdast-util-directive'

function processCard(
  node: TextDirective | LeafDirective | ContainerDirective
) {
  node.data = node.data ?? {}
  node.data.hName = 'section'
  node.data.hProperties = {
    className: ['sc-card', node.name + '-content']
  }
}

export default processCard